export default {
  allFinancialCategories: [],
}
